import React, {memo, useState, useCallback, useEffect, useMemo} from "react"
import {SettingReadOnlyRowComponent} from "../../../../../components/Settings/SettingReadOnlyRowComponent"
import {SettingsPageContainer} from "../../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../../components/PasswordContainer"
import gif from "../../../../../assets/images/gif/fogo-computer.gif"
import {useLocalization} from "../../../../../hooks/localization"
import {SystemInfoTest} from "../../../../../store/control/state"
import {useQuestion} from "../../../../../hooks/question"
import {useRPC} from "../../../../../hooks/rpc"
import "./index.scss"

export const SystemInfoTestScreen = memo(function SystemInfoTestScreen() {
    const {t} = useLocalization()
    const [rpc] = useRPC()
    const question = useQuestion()
    const [systemTestInfo, setSyatemTestInfo] = useState<SystemInfoTest>(null)
    const [stressTestCounter, setStressTestCounter] = useState(false)
    const [timeValue, setTimeValue] = useState(60)

    const loadSystemInfo = useCallback(() => rpc.getSystemInfoInTest().then(data => setSyatemTestInfo(data)), [rpc])

    const onRefreshPressed = useCallback(() => loadSystemInfo(), [loadSystemInfo])

    const onStressTest = useCallback(() => {
        question(t("are_you_sure"), () => {
            setStressTestCounter(true)
            rpc.startStressTest()
                .catch(console.log)
                .finally(() => setStressTestCounter(false))
            let time = timeValue
            const timer = setInterval(() => {
                time--
                if (time >= 1) {
                    setTimeValue(time)
                } else {
                    setStressTestCounter(false)
                }
            }, 1000)
            return () => clearInterval(timer)
        })
    }, [t, question, rpc, timeValue])

    const buttons = useMemo(
        () => [
            {
                text: "STRES TESTİ",
                className: "blue",
                onClick: onStressTest
            },
            {
                text: t("refresh"),
                className: "green",
                onClick: onRefreshPressed
            }
        ],
        [t, onRefreshPressed, onStressTest]
    )

    useEffect(() => {
        loadSystemInfo()
    }, [loadSystemInfo])

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            {renderIf(stressTestCounter)(() => (
                <div className="stress-test-counter">
                    <span>{timeValue}</span>sn
                    <span>Test devam ediyor...</span>
                    <span>
                        <img src={gif} alt="" />
                    </span>
                </div>
            ))}

            <SettingsPageContainer
                buttons={buttons}
                className="service-edit"
                backUrl={"/settings/advanced-settings/test"}
            >
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingReadOnlyRowComponent title={"İşletim Sistemi"} value={systemTestInfo?.linux_version} />
                        <SettingReadOnlyRowComponent title={"CPU Bilgisi"} value={systemTestInfo?.cpu_info} />
                        <SettingReadOnlyRowComponent title={"CPU Kullanımı"} value={systemTestInfo?.cpu_usage} />
                        <SettingReadOnlyRowComponent title={"CPU Sıcaklığı"} value={systemTestInfo?.cpu_temp} />
                        <SettingReadOnlyRowComponent title={"Disk Kullanımı"} value={systemTestInfo?.disk_usage} />
                        <SettingReadOnlyRowComponent title={"RAM"} value={systemTestInfo?.ram_info} />
                        <SettingReadOnlyRowComponent
                            title={"Ekran Çözünürlüğü"}
                            value={systemTestInfo?.screen_resolution}
                        />
                    </div>
                    <div className="content-wrapper">
                        <SettingReadOnlyRowComponent
                            title={"12V Besleme Voltajı (mV)"}
                            value={systemTestInfo?.supply_voltage}
                        />
                        <SettingReadOnlyRowComponent
                            title={"3V Besleme Voltajı (mV)"}
                            value={systemTestInfo?.supply_voltage_3v}
                        />
                        <SettingReadOnlyRowComponent
                            title={"Donanım Versiyonu"}
                            value={systemTestInfo?.hardware_version}
                        />
                        <SettingReadOnlyRowComponent
                            title={"Donanım Sıcaklığı"}
                            value={systemTestInfo?.hardware_temp}
                        />
                        <SettingReadOnlyRowComponent
                            title={"Sensör Sıcaklığı"}
                            value={systemTestInfo?.temp_sensor_value}
                        />
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
